// extracted by mini-css-extract-plugin
export var actionButton = "_yb-2";
export var card = "_yb-0";
export var disambiguationList = "_yb-3";
export var errorCard = "_yb-4";
export var row = "_yb-1";